import { browserHistory } from 'react-router';
import * as constants from '../../constants';
/**
 *
 * Check local storage flag "loginInfo.acceptedTerms"
 *
 */
export const checkAcceptTerms = cb => {
  const acceptedTerms = localStorage.getItem('loginInfo.acceptedTerms');
  const session = localStorage.getItem('loginInfo.logged_user');
  const currentPath = window.location.pathname;
  // Validate access to navigation
  if (
    acceptedTerms == 0 &&
    session &&
    currentPath.indexOf('terms') === -1 &&
    currentPath.indexOf('terminos_y_condiciones') === -1 &&
    currentPath.indexOf('politicas_de_privacidad') === -1
  ) {
    //TODO: ROUTER ALERT
    return location.assign(`/${constants.GetRegion()}/terms`);
  }
  // Call the next dispatch method in the middleware chain.
  cb();
};
